/* eslint-disable */
import {
  mapGetters
} from 'vuex';
import {
  bus
} from '../../main';
import toast from '../../services/toast';
export default {
  name: 'edit-rlist-user',
  components: {},
  props: ['userId'],
  data() {
    return {
      userData: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        id: ''
      },
      signupactiveStatus:false,
      loginactiveStatus:false,
      paymentactiveStatus:false,
      signupactiveVal:'',
      loginactiveVal:'',
      paymentactiveVal:''

    }
  },
  computed: {
    ...mapGetters([
      'getRListUserDetailsByIdState'
    ]),
    isFirstNameRequired() {
      if (this.userData.mobile === '')
      if (this.userData.email === '')
      if (this.userData.last_name === '')
        return true; // First Nam is required
      return false;
    },
    isLastNameRequired() {
      // check if homephone is empty
      if (this.userData.email === '')
      if (this.userData.first_name === '')
      if (this.userData.mobile === '')
        return true; // Last Name is required
      return false;
    },
    isEmailRequired() {
      if (this.userData.mobile === '')
      if (this.userData.first_name === '')
      if (this.userData.last_name === '')
        return true; // email is required
      return false;
    },
    isPhoneRequired() {
      // check if homephone is empty
      if (this.userData.email === '')
      if (this.userData.first_name === '')
      if (this.userData.last_name === '')
        return true; // phone is required
      return false;
    },
    getUserDetail() {
      this.$store.dispatch('getRListUserListDetailsById', {
        id: this.userId
      }).then((res) => {
        this.userData = this.$store.getters.getRListUserDetailsByIdState.data;
        if(this.userData.restrictions.includes("signup")){
          this.signupactiveStatus = true
          this.signupactiveVal = 'signup'
          console.log("True STatus")
        }else{
          this.signupactiveStatus = false
          this.signupactiveVal = ''
          console.log("False STatus")
        } if(this.userData.restrictions.includes("login")){
          this.loginactiveStatus = true
          this.loginactiveVal = 'login'
          console.log("True STatus")
        }else{
          this.loginactiveStatus = false
          this.loginactiveVal = ''
          console.log("False STatus")
        } if(this.userData.restrictions.includes("payment")){
          this.paymentactiveStatus = true
          this.paymentactiveVal = 'payment'
          console.log("True STatus")
        }else{
          this.paymentactiveStatus = false
          this.paymentactiveVal = ''
          console.log("False STatus")
        }
      }).catch((err) => {})
    },
  },
  mounted() {
    this.getUserDetail
  },
  methods: {
    getUserListAgain() {
      this.$store.dispatch('getRlistUserList').then((res) => {
        bus.$emit('HideEditUserPopup', false);
      }).catch((err) => {})
    },
    signupactiveStatusFun(){
      if(this.signupactiveStatus == true){
        this.signupactiveStatus= false
        this.signupactiveVal = ''
      }else{
        this.signupactiveVal = 'signup'
        this.signupactiveStatus= true
      }
    },
    loginactiveStatusFun(){
      if(this.loginactiveStatus == true){
        this.loginactiveStatus= false
        this.loginactiveVal = ''
      }else{
        this.loginactiveVal = 'login'
        this.loginactiveStatus= true
      }
    },
    paymentupactiveStatusFun(){
      if(this.paymentactiveStatus == true){
        this.paymentactiveVal = ''
        this.paymentactiveStatus= false
      }else{
        this.paymentactiveVal = 'payment'
        this.paymentactiveStatus= true
      }
    },
    validateEditUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = {
            id:this.userId,
            restrictions:[]
          }
          if(this.signupactiveVal != null && this.signupactiveVal != ''){
            data.restrictions.push(this.signupactiveVal);
          }
          if(this.loginactiveVal != null && this.loginactiveVal != ''){
            data.restrictions.push(this.loginactiveVal);
          }
          if(this.paymentactiveVal != null && this.paymentactiveVal != ''){
            data.restrictions.push(this.paymentactiveVal);
          }
          if(this.userData.first_name != null && this.userData.first_name != ''){
            data.first_name = this.userData.first_name;
          }
          if(this.userData.last_name != null && this.userData.last_name != ''){
            data.last_name = this.userData.last_name;
          }
          if(this.userData.email != null && this.userData.email != ''){
            data.email = this.userData.email;
          }
          if(this.userData.mobile != null && this.userData.mobile != ''){
            data.mobile = this.userData.mobile;
          }
          this.$store.dispatch('UpdateRListUserDetailsById', data).then((res) => {
              toast.success(res.data.msg);
              this.getUserListAgain()
              this.$validator.reset();
          }).catch((err) => {})
          return;
        }
      });
    },
    PopupClose() {
      bus.$emit('HideEditUserPopup', false);
    },
  }
}